// extracted by mini-css-extract-plugin
export default {"iconRequire":"label-with-tooltip_iconRequire__ZqCK1","requireAsterisk":"label-with-tooltip_requireAsterisk__h04a-"};